import React from 'react';
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/react';
import { ChevronUpDownIcon } from '@heroicons/react/24/outline';
import useLanguage from '../../hooks/useLanguage';

const LANG_CODES = ['en', 'pt'];

const LanguageDropdown = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <Listbox value={language} onChange={setLanguage}>
      <div className="relative w-24">
        <ListboxButton className=" flex items-center justify-between border border-gray-300 rounded-md px-3 py-2 text-sm font-semibold text-gray-800 shadow-sm hover:border-yellow-400 focus:outline-none focus:ring-1 focus:ring-yellow-300">
          <span>{language.toUpperCase()}</span>
          <ChevronUpDownIcon className="h-4 w-4 text-gray-400" />
        </ListboxButton>

        <ListboxOptions className="absolute z-10 mt-2 w-full bg-white border border-gray-200 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {LANG_CODES.map((code) => (
            <ListboxOption
              key={code}
              value={code}
              className={({ active }) =>
                `px-4 py-2 cursor-pointer text-sm font-medium rounded-md ${
                  active ? 'bg-yellow-100 text-yellow-900' : 'text-gray-700'
                }`
              }
            >
              {code.toUpperCase()}
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
};

export default LanguageDropdown;
